<style scoped>
form {
  display: flex;
  flex-direction: column;
  gap: 10px;
  max-width: 700px;
  margin: 20px auto;
}

input, textarea {
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
}

button {
  padding: 10px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

button:hover {
  background-color: #0056b3;
}

ul {
  list-style-type: none;
  padding: 0;
}

.el-form {
  max-width: none; /* 移除最大宽度限制 */
}
</style>
<script>
import axios from 'axios';

export default {
  name: "OneClick",
  data() {
    return {
      formData: {
        gameName: '',
        configData: ''
      },
      valueGame: "",
      optionsGame: [],
      tasks: [],
      tasks2: [],
      combinedTasks: [],
      combinedTableData: [],
      oneClickFormData: {
        gameName: '',
        scheduleIndex: '',
        topPercentStart: '',
        topPercentEnd: '',
        oneBeginCount: ''
      }, optionsGame2: [],
      taskFormData: {

        gameName: '',
        scheduleIndex: '',
        timeRange: '',
        filterMissingBalanceField: true,
        rangeConfigs: [
          {
            topPercentStart: '',
            topPercentEnd: '',
            oneBeginCount: '',
            beginType: 0
          }
        ]
      },
      dialogVisible: false,
      drawerVisible: false,
      logsData: [],
    };
  },
  methods: {
    openAddTaskDialog() {
      this.$axios
          .get('/toufangWx/data/findName', {})
          .then(successResponse => {

            this.optionsGame2 = successResponse.data.data

          })
      this.taskFormData = {
        gameName: '',
        scheduleIndex: '',
        timeRange: '',
        filterMissingBalanceField: true,
        rangeConfigs: [
          {
            topPercentStart: '',
            topPercentEnd: '',
            oneBeginCount: '',
            beginType: 0
          }
        ]
      }
      this.dialogVisible = true; // 打开对话框
    },
    async delJob(row) {
      try {
        const response = await axios.get(`/schedule/delJob?gameName=${row.gameName}&scheduleIndex=${row.scheduleIndex}&id=${row.taskId}`, {

        }).then(response => {

          this.fetchTasks() ;
          console.log('删除任务成功:', response.data);

          this.$message.success('删除任务成功！');
        });

      } catch (error) {
        console.error('添加一键配置任务失败:', error);
        this.$message.error('一键配置任务添加失败，请稍后重试');
      }
    },  async delRange(row) {
      try {
        const response = await axios.get(`/schedule/delRange?id=${row.rangeId}`, {

        }).then(response => {

          this.fetchTasks() ;
          console.log('删除范围配置成功:', response.data);

          this.$message.success('删除范围配置成功！');
        });

      } catch (error) {
        console.error('添加一键配置任务失败:', error);
        this.$message.error('一键配置任务添加失败，请稍后重试');
      }
    },
    async submitAddOneClick() {
      try {
        const response = await axios.post('/schedule/addOneClick', this.oneClickFormData);
        console.log('添加一键配置任务成功:', response.data);
        this.$message.success('一键配置任务添加成功！');
      } catch (error) {
        console.error('添加一键配置任务失败:', error);
        this.$message.error('一键配置任务添加失败，请稍后重试');
      }
    }, async submitSplitRequests() {
      try {
        // 拆分 taskFormData 为多个 oneClickFormData
        const oneClickForms = this.splitTaskFormDataToMultipleOneClick();

        // 逐个发送请求
        for (const formData of oneClickForms) {
          const response = await axios.post('/schedule/addOneClick', formData);
          console.log('提交成功:', response.data);
        }

        this.$message.success('所有任务提交成功！');
      } catch (error) {
        console.error('提交失败:', error);
        this.$message.error('任务提交失败，请稍后重试');
      }
    }, splitTaskFormDataToMultipleOneClick() {
      const result = [];

      // 遍历 rangeConfigs，为每个配置项生成一个 oneClickFormData
      this.taskFormData.rangeConfigs.forEach(config => {
        const oneClickFormData = {
          gameName: this.taskFormData.gameName,
          scheduleIndex: this.taskFormData.scheduleIndex,
          timeRange: this.taskFormData.timeRange,
          topPercentStart: config.topPercentStart,
          topPercentEnd: config.topPercentEnd,
          oneBeginCount: config.oneBeginCount,
          beginType: config.beginType
        };

        result.push(oneClickFormData);
      });

      return result;
    },
    async submitAddTask() {
      try {
        const response = await axios.post('/schedule/registerTask', this.taskFormData);
        console.log('添加一键配置任务成功:', response.data);
        this.$message.success('一键配置任务添加成功！');
        this.submitSplitRequests()
        this.findGame()
        this.dialogVisible = false;
      } catch (error) {
        console.error('添加一键配置任务失败:', error);
        this.$message.error('一键配置任务添加失败，请稍后重试');
      }
    }
    ,

    async fetchTasks() {
      try {
        // 并行发起两个请求
        const [response1, response2] = await Promise.all([
          axios.get(`/schedule/getOneClick?gameName=${this.valueGame}`),
          axios.get(`/schedule/getTask?gameName=${this.valueGame}`)
        ]);

        // 初始化数据
        const task = response1.data?.data || [];
        const task2 = response2.data?.data || [];

        // 数据组合逻辑
        const result = [];

        // 遍历 task2，无论是否匹配都加入结果
        task2.forEach(t => {
          const matchedTaskList = task.filter(t2 => t2.scheduleIndex === t.scheduleIndex);

          if (matchedTaskList.length > 0) {
            // 存在匹配的 task，正常组合
            matchedTaskList.forEach(t2 => {
              result.push({
                taskId: t.id,
                rangeId: t2.id,
                gameName: t.gameName,
                timeRange: t.timeRange,
                scheduleIndex: t.scheduleIndex,
                filterMissingBalanceField: t.filterMissingBalanceField !== false,
                topPercentStart: t2.topPercentStart,
                topPercentEnd: t2.topPercentEnd,
                oneBeginCount: t2.oneBeginCount
              });
            });
          } else {
            // 不存在匹配的 task，task 部分字段留空
            result.push({
              taskId: t.id,
              rangeId: null,
              gameName: t.gameName,
              timeRange: t.timeRange,
              scheduleIndex: t.scheduleIndex,
              filterMissingBalanceField: t.filterMissingBalanceField !== false,
              topPercentStart: null,
              topPercentEnd: null,
              oneBeginCount: null
            });
          }
        });

        // 更新表格数据
        this.combinedTableData = result;

        console.log('组合后的数据:', result);
      } catch (error) {
        console.error('获取任务失败:', error);
        this.$message.error('获取任务失败，请稍后重试');
      }
    }, findGame() {

      this.$axios
          .get('/schedule/getTaskName', {})
          .then(successResponse => {

            this.optionsGame = successResponse.data.data

          })


    },   async findLogs() {
      try {
        const response = await this.$axios.get(`/schedule/getLogs?gameName=${this.valueGame}`);
        this.logsData = response.data.data || []; // 设置日志数据
        this.drawerVisible = true; // 打开抽屉
      } catch (error) {
        console.error('查询日志失败:', error);
        this.$message.error('查询日志失败，请稍后重试');
      }
    }
  , addRangeConfig() {
      this.taskFormData.rangeConfigs.push({
        topPercentStart: '',
        topPercentEnd: '',
        oneBeginCount: '',
        beginType: 0
      });
    },
    removeRangeConfig(index) {
      this.taskFormData.rangeConfigs.splice(index, 1);
    },
  },
  mounted() {
    // 页面加载时自动获取任务
    this.findGame()
    // this.fetchTasks();

  }
};
</script>
<template>
  <div>
    <template>
      <div class="bbb" style="margin-left: 10px">
        <h2>一键配置任务</h2>
        <div>
          <el-select v-model="valueGame" placeholder="游戏选择" size="mini"
                     style="margin-top: 5px;align-items: center;width: 150px"
                     filterable clearable allow-create>
            <el-option
                v-for="item in optionsGame"
                :key="item"
                :label="item"
                :value="item">
            </el-option>
          </el-select>

          <el-button type="primary" @click="fetchTasks" style="width: 120px;margin-left: 5px" size="mini">查询
          </el-button>

          <el-button type="danger" @click="openAddTaskDialog" style="width: 120px" size="mini">添加任务</el-button>
          <el-button type="primary" @click="findLogs" style="width: 120px;margin-left: 5px" size="mini">查询日志
          </el-button>

          <!-- 抽屉组件 -->
          <el-drawer
              title="日志详情"
              :visible.sync="drawerVisible"
              direction="rtl"
              size="60%"
          >
            <el-table :data="logsData" style="width: 100%" size="mini">
              <el-table-column prop="accountId" label="账户ID" width="100"></el-table-column>
              <el-table-column prop="advertiserId" label="广告主ID" width="120"></el-table-column>
              <el-table-column prop="beginCount" label="起量预算" width="100"></el-table-column>
              <el-table-column prop="gameName" label="游戏名称" width="250"></el-table-column>
              <el-table-column prop="miniGameRoi" label="小游戏ROI" width="120"></el-table-column>
              <el-table-column prop="statCost" label="消耗" width="100"></el-table-column>
              <el-table-column prop="uploadTime" label="操作时间" width="200"></el-table-column>
            </el-table>
          </el-drawer>
        </div>
        <div>
          <h3>已有配置任务</h3>
          <el-table :data="combinedTableData" style="width: 100%" size="mini">

            <el-table-column prop="scheduleIndex" label="任务序号" width="150"></el-table-column>
            <el-table-column prop="gameName" label="游戏名称" width="280"></el-table-column>
            <el-table-column prop="timeRange" label="开启时间" width="150"></el-table-column>
            <el-table-column prop="filterMissingBalanceField" label="过滤缺少余额字段" width="150">
              <template slot-scope="scope">
                <el-tag size="mini" :type="scope.row.filterMissingBalanceField ? 'warning' : 'info'">
                  {{ scope.row.filterMissingBalanceField ? '过滤' : '不过滤' }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column label="百分比范围" width="200">
              <template slot-scope="scope">
                {{ scope.row.topPercentStart }} ~ {{ scope.row.topPercentEnd }}%
              </template>
            </el-table-column>
            <el-table-column prop="oneBeginCount" label="起量预算"></el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button type="danger" @click="delJob(scope.row)" size="mini">删除任务</el-button>
                <el-button type="danger" @click="delRange(scope.row)" size="mini">删除范围</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <!-- 添加任务的对话框 -->
      <el-dialog title="添加任务" :visible.sync="dialogVisible" width="1000px">
        <el-form :model="taskFormData" label-width="100px">
          <!-- 游戏名称 -->
          <el-form-item label="游戏名称">
            <el-select v-model="taskFormData.gameName" placeholder="游戏选择" required filterable allow-create
                       clearable>
              <el-option
                  v-for="item in optionsGame2"
                  :key="item"
                  :label="item"
                  :value="item">
              </el-option>
            </el-select>
          </el-form-item>

          <!-- 任务序号 -->
          <el-form-item label="任务序号">
            <el-input v-model="taskFormData.scheduleIndex" required style="width: 200px"/>
          </el-form-item>

          <!-- 开启时间 -->
          <el-form-item label="开启时间">
            <el-time-picker
                v-model="taskFormData.timeRange"
                format="HH:mm"
                value-format="HH:mm"
                placeholder="请选择时间"
                required
            />
          </el-form-item>

          <el-form-item label="余额字段">
            <el-switch
                v-model="taskFormData.filterMissingBalanceField"
                active-text="过滤缺少 balance 的账号"
                inactive-text="不过滤"
            />
            <div style="font-size: 12px; color: #909399; line-height: 20px; margin-top: 4px;">
              开启后，腾讯账号日报没有返回 balance 字段的账号会被排除；关闭后仍按日预算等条件判断。
            </div>
          </el-form-item>

          <!-- 范围配置（动态添加） -->
          <el-form-item label="范围配置">
            <div v-for="(config, index) in taskFormData.rangeConfigs" :key="index" style="margin-bottom: 10px;">
              <el-input
                  v-model="config.topPercentStart"
                  :placeholder="config.beginType === 0 ? '起始百分比10' : '起始小数点0.1'" style="width: 20%; margin-right: 10px;"
                  required
              />
              <el-input
                  v-model="config.topPercentEnd"
                  :placeholder="config.beginType === 0 ? '结束百分比10' : '结束小数点0.1'"  style="width: 20%; margin-right: 10px;"
                  required
              />
              <el-input
                  v-model="config.oneBeginCount"
                  placeholder="起量预算" style="width: 30%;"
                  required
              />

              <!-- beginType 选择器 -->
              <el-select
                  v-model="config.beginType"
                  placeholder="选择类型"        style="width: 20%; margin-left: 10px;"
                  required
              >
                <el-option label="ROI排行" :value="0"></el-option>
                <el-option label="ROI范围" :value="1"></el-option>
              </el-select>
              <el-button @click="removeRangeConfig(index)" type="danger" style="margin-left: 5px" icon="el-icon-delete"
                         circle></el-button>
            </div>
            <el-button @click="addRangeConfig" type="primary" icon="el-icon-plus">添加范围</el-button>
          </el-form-item>

          <!-- 提交按钮 -->
          <el-form-item>
            <el-button type="primary" @click="submitAddTask" style="width: 100px">提交</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
    </template>

  </div>
</template>
